import { useEffect, useState } from "react";
import {
    ACTIVE_COMPANY_EVENT,
    getActiveCompanyId,
} from "./client";

type ActiveCompanyState = {
    value: string | null;
    resolved: boolean;
};

export function useActiveCompanyId(): ActiveCompanyState {
    const [state, setState] = useState<ActiveCompanyState>(() => {
        return {
            value: getActiveCompanyId(),
            resolved: false,
        };
    });

    useEffect(() => {
        const syncFromStorage = () => {
            setState({
                value: getActiveCompanyId(),
                resolved: true,
            });
        };

        const handleCompanyChange = (event: Event) => {
            const detail = (event as CustomEvent<{ id?: string | null }>).detail;

            setState({
                value: detail?.id ?? getActiveCompanyId(),
                resolved: true,
            });
        };

        window.addEventListener("storage", syncFromStorage);
        window.addEventListener(ACTIVE_COMPANY_EVENT, handleCompanyChange as EventListener);
        syncFromStorage();

        return () => {
            window.removeEventListener("storage", syncFromStorage);
            window.removeEventListener(ACTIVE_COMPANY_EVENT, handleCompanyChange as EventListener);
        };
    }, []);

    return state;
}
